import { FC } from 'react';

import { EnquiryType } from '@shared/api/enquiry/enquiry.interface';
import { EnquiryPanel } from '@shared/containers/EnquiryForm/EnquiryPanel';

/**
 * 답례품 배송관리자(공급사) 콘솔의 1:1 문의 — 관리자 문의사항 관리의 "셀러" 탭으로 들어간다.
 * 사이드바 레이아웃이라 좁은 폼 폭으로 가운데 정렬한다.
 */
export const GiftBrandEnquiryPage: FC = () => {
  return (
    <div className="mx-auto max-w-xl rounded-lg bg-white shadow-sm">
      <EnquiryPanel type={EnquiryType.Seller} />
    </div>
  );
};
